import { faPlaneArrival, faPlaneDeparture } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ValidSegmentAirport } from "components/FareSearch/Business/ValidateSearch";
import { AirportType, dropdownItem, IFareSearchInputState, ISegmentState } from "components/FareSearch/types/FareSearchTypes";
import { AgentApiURL } from "Constants";
import React, { useEffect, useState } from "react";
import { ArrowContainer, Popover, PopoverState } from "react-tiny-popover";
import { Card, ListGroup, ListGroupItem } from "reactstrap";
import { ApiCredentialsOptions, Idestination, PublicServicesClient, } from "WebApiClient";
import nextElementFocus from './nextElementFocus';

interface OwnProps {
    SegmentIndex: number;
    Segment: ISegmentState;
    AirportType: AirportType;
    UpdateSegment: (index: number, segment: ISegmentState) => void
    OnSelectNextElem(type: AirportType): void;
    departureCollector?: any;
    setdepartureCollector?: any;
    arrivalCollector?: any;
    isInValidMonth: boolean;
    reference: any;
    tabIndex: number;
    invalidInputs: { field: string; value: string; tabIndex: number }[];
    isSubmitTrigger: boolean;
    UpdateState: (state: IFareSearchInputState) => void;
    setDestinationCollector: React.Dispatch<React.SetStateAction<Idestination[][]>>;
}

const AirportInput: React.FC<OwnProps> = props => {
    const debug = false;
    const segment = props.Segment;
    const isDeparture: boolean = props.AirportType === AirportType.Departure;
    const PrependIcon: JSX.Element = isDeparture ? <FontAwesomeIcon icon={faPlaneDeparture} /> : <FontAwesomeIcon icon={faPlaneArrival} />;
    const IconTitle: string = isDeparture ? "Outbound" : "Inbound";
    const InputID: string = `segment${props.SegmentIndex}_airport${props.AirportType}`;
    const InputAutoFocus: boolean = isDeparture && props.SegmentIndex === 0;
    const isInValidMonth = props.isInValidMonth;
    const [InputVal, setInputVal] = useState("");
    const [InputActive, setInputActive] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [items, setItems] = useState<dropdownItem[]>([])
    const [activeAutoCompleteItem, setActiveAutoCompleteItem] = useState(0);
    const [reTriggerValid, setReTriggerValid] = useState(false);
    const [isShortcutUsed, setIsShortcutUsed] = useState(false);
    var isNativeSearch: boolean = false;

    function GetInputValidLabel(): string {
        const isValid = ValidSegmentAirport(InputVal);
        if (isValid) return "is-valid"
        return "is-invalid";
    };

    function GetInputValidMonth(): string {
        const isInValid = isInValidMonth;
        if (isInValid) return "is-invalid"
        return "is-valid";

    };


    useEffect(() => {
        const newVal = isDeparture ? props.Segment.DepartureInput : props.Segment.ArrivalInput;
        setInputVal(newVal);
    }, [props.Segment.DepartureInput, props.Segment.ArrivalInput]);

    function OnSearch(val: string) {
        const value = val.toUpperCase().trim();

        if (!isNativeSearch) setInputVal(val);
        setInputActive(true);
        if (/^[A-Z]{6}\d{4}$/.test(value)) {
            const dep = value.slice(0, 3);
            const arr = value.slice(3, 6);
            const day = Number(value.slice(6, 8));
            const month = Number(value.slice(8, 10));

            const newCollector = {
                departureL: dep,
                arrivalL: arr,
                DayL: day,
                MonthL: month,
            };

            props.setdepartureCollector(newCollector);
            setIsShortcutUsed(true);
            setItems([]); // clear list
            setTimeout(() => {
                setInputVal("");
                props.reference?.current?.focus();
            }, 50);
            return;
        }

        // Prevent immediate auto-search after shortcut
        if (isShortcutUsed) {
            setIsShortcutUsed(false);
            return;
        }


        if (value.length < 3) return;

        const client = new PublicServicesClient(new ApiCredentialsOptions(AgentApiURL, ""));
        setIsLoading(true);

        client.getAirportsByPrefix(value)
            .then((result) => {
                if (!result || result.length === 0) {
                    setItems([]);
                    return;
                }

                const map = result.map((e) => ({
                    value: e.iata!,
                    text: `[${e.iata}] - ${e.cityName} - ${e.name}`,
                    image: e.countryCode!,
                    cityCode: e.cityCode,
                    allAirports: e.allAirports,
                }));
                setItems(map);
            })
            .catch(() => {
                console.warn("❌ Failed to load airport for:", value);
                setItems([]);
            })
            .finally(() => setIsLoading(false));
    }



    const AirportAutoCompleteOptions = items.map((airport, index) =>
        <ListGroupItem
            className={`btn-sm`}
            key={`ac_${props.AirportType}_${props.SegmentIndex}_${index}`}
            onMouseEnter={() => setActiveAutoCompleteItem(index)}
            active={activeAutoCompleteItem === index}
            onClick={() => { OnAutocompleteClick(index) }}
            tag="button"
            action>
            <img src={`/images/flags/${airport.image.toLowerCase()}.png`} alt="airport" />{` `}
            <span>{airport.text}</span>
        </ListGroupItem>
    );
    function OnAutocompleteClick(index: number) {
        OnSelectAutocompleteItem();
    };
    function AirportLabel(): string {
        if (isLoading) {
            return "loading..."
        }
        if (InputVal.length < 2) {
            return "Type to see results..."
        }
        if (items.length > 0) {
            return `${items.length.toString()} Airports found`;
        }
        return "Type to see results...";
    };
    function ToolTipContent(popoverState: PopoverState): JSX.Element {
        return <ArrowContainer position={popoverState.position} childRect={popoverState.childRect} popoverRect={popoverState.popoverRect} arrowColor="black" arrowSize={5}>
            <Card>
                <span className="text-center ">{AirportLabel()}</span>
                {/* <CardBody className="small"> */}
                {items.length > 0 &&
                    <ListGroup flush={true}>
                        {AirportAutoCompleteOptions}
                    </ListGroup>
                }
                {/* </CardBody> */}
            </Card>
        </ArrowContainer>
    };
    function OnFocus(e: React.FocusEvent<HTMLInputElement>) {
        e.stopPropagation();
        if (debug) {
            console.log(`Focus: ${isDeparture ? "Departure" : "Arrival"}`)
        }
        setInputActive(true);
        e.target.select();
    };
    function OnKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
        const key = event.which;
        if (key === 40 || key === 38 || key === 13 || key === 9) {
            if (!(key === 13 && event.ctrlKey)) {
                // event.preventDefault();
                event.stopPropagation();
                if (key === 40) { //down arrow             
                    if (activeAutoCompleteItem < items.length - 1) {
                        setActiveAutoCompleteItem(activeAutoCompleteItem + 1)
                    }
                }
                if (key === 38) { //up arrow                                       
                    if (activeAutoCompleteItem > 0) {
                        setActiveAutoCompleteItem(activeAutoCompleteItem - 1)
                    }
                }
                if (!event.shiftKey && event.keyCode) {
                    if (key === 13 || key === 9) { // tab/enter
                        OnSelectAutocompleteItem(true);
                    }
                }
            }
        }
    };
    function OnPopoverClickOutside() {
        if (debug) {
            console.log(`OnPopoverClickOutside: ${isDeparture ? "Departure" : "Arrival"}`)
        }
        setInputActive(false);
    };
    function OnSelectAutocompleteItem(shouldFocusNext: boolean = true) {
        const selectedItem = items[activeAutoCompleteItem] || items[0];
        if (!selectedItem) return;

        const value = selectedItem.text;
        OnSearch(value);

        if (debug) {
            console.log(`OnSelectAutocompleteItem: ${isDeparture ? "Departure" : "Arrival"}`);
        }

        if (items[activeAutoCompleteItem] !== undefined) {
            const autoCompleteItem = items[activeAutoCompleteItem];
            const value = autoCompleteItem.text;
            OnValueChanged(value);
        }

        setInputActive(false);

        if (shouldFocusNext) {
            setTimeout(function () {
                props.OnSelectNextElem(props.AirportType);
            }, 100);
        }
    }
    function OnValueChanged(value: string) {
        if (debug) {
            console.log(`OnValueChanged: ${isDeparture ? "Departure" : "Arrival"}`)
        }

        if (isDeparture) {
            const segment: ISegmentState = { ...props.Segment, DepartureInput: value,
                departure: items[activeAutoCompleteItem]
                ? {
                    iataCode: items[activeAutoCompleteItem].value,
                    cityCode: items[activeAutoCompleteItem].cityCode,
                    allAirports: items[activeAutoCompleteItem].allAirports
                }
                : props.Segment.departure};
            props.UpdateSegment(props.SegmentIndex, segment);

        }
        else {
            const segment: ISegmentState = { ...props.Segment, ArrivalInput: value,
                arrival: items[activeAutoCompleteItem]
                ? {
                    iataCode: items[activeAutoCompleteItem].value,
                    cityCode: items[activeAutoCompleteItem].cityCode,
                    allAirports: items[activeAutoCompleteItem].allAirports
                }
                : props.Segment.departure };
            props.UpdateSegment(props.SegmentIndex, segment);
        }
    };
    function GetItems(val: string): Promise<dropdownItem[]> {
        const trimmed = val?.trim();

        // ✅ Guard against empty or too-short values
        if (!trimmed || trimmed.length < 3) {
            console.warn("⚠️ Skipping GetAirportsByPrefix - invalid prefix:", val);
            return Promise.resolve([]);
        }

        const client = new PublicServicesClient(
            new ApiCredentialsOptions(AgentApiURL, "")
        );

        return client.getAirportsByPrefix(trimmed)
            .then((result) => {
                if (result.length > 0) {
                    return result.map(e => ({
                        value: e.iata!,
                        text: `[${e.iata}] - ${e.cityName} - ${e.name}`,
                        image: e.countryCode!,
                        cityCode: e.cityCode,
                        allAirports: e.allAirports
                    }));
                } else {
                    return [];
                }
            })
            .catch((err) => {
                console.error("❌ Failed to fetch airports:", err);
                return [];
            });
    }

    async function removeInvalids() {
        for (const inputs of props.invalidInputs) {
            if (props.tabIndex === inputs?.tabIndex) {
                const newItems: dropdownItem[] = items?.length > 0 ? items : await GetItems(inputs.value);
                if (newItems[activeAutoCompleteItem] !== undefined &&
                    (segment.ArrivalInput?.length < 4 || segment?.DepartureInput.length < 4)) {
                    const autoCompleteItem = newItems[activeAutoCompleteItem];
                    const value = autoCompleteItem.text;
                    console.log("value-----", value);

                    if (inputs.field === "DepartureInput") {
                        const segment: ISegmentState = { ...props.Segment, DepartureInput: value, departure: { allAirports: autoCompleteItem.allAirports, cityCode: autoCompleteItem.cityCode, iataCode: autoCompleteItem.value } };
                        setReTriggerValid(prev => !prev);
                        props.UpdateSegment(props.SegmentIndex, segment);
                    } else {
                        const segment: ISegmentState = { ...props.Segment, ArrivalInput: value, arrival: { allAirports: autoCompleteItem.allAirports, cityCode: autoCompleteItem.cityCode, iataCode: autoCompleteItem.value } };
                        setReTriggerValid(prev => !prev);
                        props.UpdateSegment(props.SegmentIndex, segment);
                    }
                }
            }
        }
    }
    useEffect(() => {
        if (props?.invalidInputs?.length > 0) {
            removeInvalids();
        }
    }, [props.isSubmitTrigger, reTriggerValid])
    const OnBlur = () => {
        OnSelectAutocompleteItem(false);
    };
    return (
        <Popover onClickOutside={OnPopoverClickOutside} positions={['bottom', 'right', 'left', 'top']} isOpen={InputActive} containerStyle={{ zIndex: "100" }} content={(popoverState: PopoverState) => (ToolTipContent(popoverState))}>
            <div className="input-group">
                <span className="input-group-text" title={`${IconTitle} Airport`}>
                    {PrependIcon}
                </span>
                <input id={InputID} className={`form-control ${GetInputValidLabel()} ${GetInputValidMonth()}`}
                    tabIndex={props.tabIndex}
                    value={InputVal}
                    onChange={(e) => OnSearch(e.target.value)}
                    onFocus={OnFocus}
                    autoComplete={"off"}
                    autoFocus={InputAutoFocus}
                    onKeyDown={(event) => { OnKeyDown(event); nextElementFocus({ tabIndex: props.tabIndex, reference: { airlineRef: props.reference } }) }}
                    ref={props.reference}
                    onBlur={OnBlur}
                />
            </div>
        </Popover>
    );
};

export default AirportInput;